import { useTranslation } from "react-i18next";

const COUNTRIES = ["IT", "ES", "FR", "DE", "GB", "PT", "CH", "AT", "BE", "NL"];

export const emptyShipping = { firstName: "", lastName: "", address: "", city: "", zip: "", country: "IT", email: "", phone: "", referrer: "" };

export const validateShipping = (f) => {
  const req = ["firstName", "lastName", "address", "city", "zip", "country", "email"];
  if (req.some((k) => !String(f[k] || "").trim())) return "errRequired";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) return "errEmail";
  return null;
};

const Field = ({ id, label, value, onChange, type = "text", required = true, className = "", autoComplete }) => (
  <div className={className}>
    <label htmlFor={id} className="nv-label">{label}{required && <span className="text-[#9ccc00]"> *</span>}</label>
    <input id={id} data-testid={`field-${id}`} type={type} value={value} onChange={(e) => onChange(id, e.target.value)} autoComplete={autoComplete} className="nv-input" />
  </div>
);

export const ShippingForm = ({ form, onChange, withEmail = true, withReferrer = false }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <Field id="firstName" label={t("auth.firstName")} value={form.firstName} onChange={onChange} autoComplete="given-name" />
      <Field id="lastName" label={t("auth.lastName")} value={form.lastName} onChange={onChange} autoComplete="family-name" />
      <Field id="address" label={t("auth.address")} value={form.address} onChange={onChange} className="sm:col-span-2" autoComplete="street-address" />
      <Field id="city" label={t("auth.city")} value={form.city} onChange={onChange} autoComplete="address-level2" />
      <Field id="zip" label={t("auth.zip")} value={form.zip} onChange={onChange} autoComplete="postal-code" />
      <div>
        <label htmlFor="country" className="nv-label">{t("auth.country")}<span className="text-[#9ccc00]"> *</span></label>
        <select id="country" data-testid="field-country" value={form.country} onChange={(e) => onChange("country", e.target.value)} className="nv-input">
          {COUNTRIES.map((c) => <option key={c} value={c}>{t(`countries.${c}`)}</option>)}
        </select>
      </div>
      <Field id="phone" label={t("auth.phone")} value={form.phone} onChange={onChange} type="tel" required={false} autoComplete="tel" />
      {withEmail && <Field id="email" label={t("auth.email")} value={form.email} onChange={onChange} type="email" className="sm:col-span-2" autoComplete="email" />}
      {withReferrer && <Field id="referrer" label={t("auth.referrer")} value={form.referrer || ""} onChange={onChange} className="sm:col-span-2" autoComplete="off" />}
    </div>
  );
};
